import { createSlice } from "@reduxjs/toolkit";
import { unAcceptedBookings, usermanagement, userTransaction } from "../Actions/AdminActions";

export const usermanageSlice = createSlice({
    name: "usermanageSlice",
    initialState: {
        alldata: "",
        transactionData: {},
        loading: false,
        error: null,
        unAcceptedBookingData: {}
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(usermanagement.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(usermanagement.fulfilled, (state, action) => {
                state.loading = false;
                state.alldata = action.payload.data;
            })
            .addCase(userTransaction.fulfilled, (state, action) => {
                state.loading = false;
                state.transactionData = action.payload.data.data;
            })
            .addCase(usermanagement.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(unAcceptedBookings.fulfilled, (state, action) => {
                state.loading = false;
                state.unAcceptedBookingData = action.payload.data.data;
            })

    },
});

export default usermanageSlice.reducer;
